import { useGameStore } from '../../store/gameStore';
import { BOARD_CELLS } from '../../data';
import { useAutoConfirm } from '../../hooks/useAutoConfirm';
import type { Player } from '../../types';
import styles from './BankruptcyLiquidation.module.css';

export default function BankruptcyLiquidation() {
  const {
    pendingBankruptPlayerId,
    players,
    sellPropertyForLiquidation,
    confirmBankruptcy,
    cancelBankruptcyLiquidation,
  } = useGameStore();

  const player = players.find(p => p.id === pendingBankruptPlayerId) as Player | undefined;
  
  const { countdown, cancelAutoConfirm } = useAutoConfirm({
    onAutoConfirm: () => confirmBankruptcy(),
    delayMs: 10000,
    enabled: true,
  });
  
  if (!player) return null;

  const playerProperties = player.properties
    .map(cellId => BOARD_CELLS[cellId])
    .filter(Boolean)
    .sort((a, b) => (a.price || 0) - (b.price || 0)); // 按价格升序

  const totalPropertyValue = playerProperties.reduce((sum, cell) => sum + (cell.price || 0), 0);
  const canRecover = player.money + totalPropertyValue > 0;

  const handleSell = (cellId: number) => {
    sellPropertyForLiquidation(player.id, cellId);
  };

  const handleConfirmBankrupt = () => {
    confirmBankruptcy();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <span className={styles.warning}>⚠️ 破产清算</span>
        </div>

        <div className={styles.info}>
          <p>{player.name} 的资产不足，需要进行破产清算！</p>
          <p>当前现金：<span className={styles.money}>¥{player.money}</span></p>
          <p>可变卖地产总价值：<span className={styles.value}>¥{totalPropertyValue}</span></p>
        </div>

        <div className={styles.propertyList}>
          <h4>可变卖地产：</h4>
          {playerProperties.length === 0 ? (
            <p className={styles.empty}>没有可变卖的地产，确认破产</p>
          ) : (
            playerProperties.map(cell => (
              <div key={cell.id} className={styles.propertyItem}>
                <span className={styles.propertyEmoji}>{cell.emoji}</span>
                <span className={styles.propertyName}>{cell.name}</span>
                <span className={styles.propertyPrice}>¥{cell.price}</span>
                <button
                  className={styles.sellBtn}
                  onClick={() => { cancelAutoConfirm(); handleSell(cell.id); }}
                >
                  变卖
                </button>
              </div>
            ))
          )}
        </div>

        <div className={styles.countdown}>⏰ {countdown}s 后自动确认破产</div>

        <div className={styles.actions}>
          {playerProperties.length > 0 && player.money <= 0 && (
            <button className={styles.confirmBtn} onClick={() => { cancelAutoConfirm(); handleConfirmBankrupt(); }}>
              放弃清算，确认破产
            </button>
          )}
          {player.money > 0 && (
            <button className={styles.cancelBtn} onClick={() => { cancelAutoConfirm(); cancelBankruptcyLiquidation(); }}>
              ✅ 现金已转正，继续游戏
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
